var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"gst-event-status-chip__cancelled",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.$t('cancelled'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }